<template>
  <div class="part part_about">
    <div class="title"> 
      <img src="../../static/other/line.png"/>
        <h2>隐私政策</h2>
        <h2>PRIVATE PROTOCOL</h2>
    </div>    
    <el-row>
      <el-col :xs="24" :sm="24" class="about_left">
        <div class="wrap">

          隐私政策

<br>版本生效时间：2023年11月01日
<br>开发者：
<br>店玖盟
<br>欢迎您使用店玖盟提供的产品、技术与服务！
<br>我们店玖盟深知个人信息对您的重要性，因此，我们将以高度重视、严谨审慎的态度对待及处理您的隐私及个人信息保护事宜。我们将严格遵守法律法规的规定，遵循隐私保护原则，为您提供安全、可靠的服务。
<br>请您在使用或继续使用店玖盟的产品、技术与服务前，务必仔细阅读和充分理解本《店玖盟隐私政策》，在您同意全部内容后，方可使用或继续使用。
<br>本《店玖盟隐私政策》（“本政策”）将帮助您了解以下信息：
<br>一、本政策的适用范围及定义
<br>二、我们如何收集和使用您的个人信息
<br>三、我们如何使用Cookie和同类技术
<br>四、我们如何共享、转让、公开披露您的个人信息
<br>五、您对个人信息享有的控制权
<br>六、我们如何存储您的个人信息
<br>七、我们如何保护您的个人信息
<br>八、未成年人保护（含儿童个人信息保护规则）
<br>九、关于我们及如何联系我们
<br>十、其他
<br>十一、第三方SDK共享信息
<br>本政策与您所使用的我们的产品、技术与服务密切相关，我们希望您能审慎阅读、充分理解本政策的各项内容，特别是免除或限制责任的相应内容，以及开通或使用某项服务时，可能需要另行确认或阅读的单独条款或提示，并自主做出您认为适当的选择。
本政策中与您的权益可能存在重大关系的条款，我们已采用加粗字体来特别提醒，涉及您的个人敏感信息部分，我们已采用加粗且加下划线方式来特别提醒；该等内容，请您务必重点留意并查阅。
<br>您应当在充分理解本政策后使用我们的产品、技术与服务，如果您不同意本政策的内容，将可能导致我们的产品、技术与服务无法正常运行，或者无法达到我们拟达到的服务效果；如您不同意本政策的，您应立即停止访问或使用我们的产品、技术与服务。
您使用或继续使用我们提供的产品、技术与服务的行为，都表示您充分理解和同意本政策（包括本政策后续更新之版本）的全部内容。
<br>我们的产品基于DCloud uni-app(5+ App/Wap2App)开发，应用运行期间需要收集您的设备唯一识别码（IMEI/android ID/DEVICE_ID/IDFA、SIM 卡 IMSI 信息、OAID）以提供统计分析服务，并通过应用启动数据及异常错误日志分析改进性能和用户体验，存在收集设备MAC地址、软件安装列表的行为为用户提供更好的服务。详情内容请访问《DCloud用户服务条款》。（DCloud用户服务条款超链至：https://ask.dcloud.net.cn/protocol.html）
设备信息：我们会根据您在软件安装及/或使用中的具体操作，为了保障软件与服务的安全运行，我们会收集您的硬件型号、操作系统版本号、唯一设备识别码（IMEI/android ID/IDFA/OPENUDID/GUID/OAID、SIM 卡 IMSI 信息）、设备Mac地址、IP 地址、WLAN接入点、蓝牙、基站、软件版本号、网络接入方式、类型、操作、使用日志。浏览器类型和设置、语言设置、操作系统和应用程序版本、网络设备硬件地址、登录IP地址、接入网络的方式、网络质量数据、移动网络信息（包括运营商名称）、使用手机传感器权限、产品版本号。请您理解，为动态检测您的账户是否存在异常登录，每次您后台切换或重新启动程序时，我们可能会再次读取您的设备唯一标识符信息我们将把读取频次控制在合理范围内。
如您在阅读本政策过程中有任何疑惑或其他相关事宜的，我们为您提供了多种反馈渠道，具体请见本政策“如何联系我们”章节，我们会尽快为您做出解答。
<br>一、本政策的适用范围及定义
<br>A、适用范围
<br>我们的所有产品、技术及/或服务均适用本政策，无论该产品、技术及/或服务是否单独设置了隐私条款，也无论您是浏览用户（访客）、注册登录用户。
<br>您在下载、安装、启动、浏览、注册、登录、使用我们的产品、技术及/或服务（以下统称“使用我们的产品、技术及/或服务”）时，我们将按照本政策的约定处理和保护您的个人信息，因此我们希望您能够仔细阅读、充分理解本政策的全文，并在需要时，按照本政策的指引，做出您认为适当的选择。 我们的某些产品、技术或服务可能有其特定的隐私指引/声明/提示，则该特定隐私指引/声明/提示更具体地说明我们在该项服务中如何处理您的信息。如本政策与特定服务的隐私指引/声明/提示有不一致之处，则就具体处理方法，以该特定隐私指引/声明/提示为准。 但请您注意，本政策不适用于由其他公司或个人提供的服务，具体包括：（一）您通过使用店玖盟登录其他公司或个人提供的服务；（二）为我们的产品、技术及/或服务提供广告服务的第三方的信息收集/处理做法；（三）我们的产品、技术及/或服务可能会包含或链接至第三方提供的信息及/或第三方服务（包括任何第三方应用、网站、产品、服务）；（四）其他非店玖盟向您提供的产品、技术及/或服务。前述服务由第三方负责运营，您使用该等信息及/或服务与我们无关。我们在此善意的提醒您，您在使用第三方信息及/或服务时，应留意和仔细阅读第三方向您展示的相关用户协议和隐私政策，并妥善保管和谨慎提供您的个人信息。您使用相关第三方服务须受其隐私政策（而非本政策）约束，您需要仔细阅读其政策内容。本政策仅适用于我们所收集的您的个人信息，并不适用于任何第三方对您的个人信息的收集，以及任何第三方提供的服务或第三方的信息使用规则，我们对任何第三方收集、储存和使用的您个人信息的行为在法律允许的范围内亦不承担任何责任。
<br>B、相关定义
<br>1. 我们的产品、技术及/或服务：包括我们提供的软件、网站、服务（含站外服务）以及包含的相关产品或服务功能。本政策所述之“我们的产品、技术及/或服务”以及我们收集的您个人信息的类型可能会因您使用的具体的产品/服务（包括客户端类型、软件版本）而有所不同，具体以您实际使用的产品/服务的实际情况为准。
<br>2. 个人信息（出自于GB/T 35273-2017《信息安全技术 个人信息安全规范》）：指以电子或者其他方式记录的能够单独或者与其他信息结合识别特定自然人身份或者反映特定自然人活动情况的各种信息。例如：个人基本资料（包括个人姓名、生日、性别、住址、个人电话号码、电子邮箱）、个人身份信息（包括身份证信息）、个人生物识别信息、网络身份标识信息（包括系统账号、IP地址、邮箱地址以及与前述有关的密码、口令、口令保护答案、用户个人数字证书）、资金信息（包括资金数量、收益、余额）、交易和消费记录、流水记录、虚拟货币、虚拟交易、兑换码之类的虚拟财产信息））、通讯录信息、个人上网记录（包括软件浏览记录、使用记录、点击记录）、个人常用设备信息（包括硬件序列号、硬件型号、设备MAC地址、操作系统类型、软件列表、唯一设备识别码（如IMEI/android ID/IDFA/OPENUDID/GUID、SIM卡IMSI信息在内的描述个人常用设备基本情况的信息）获取传感器信息、个人位置信息（包括大概地理位置、精准定位信息）。我们实际具体收集的个人信息种类以本政策下文描述为准。
<br>3. 个人敏感信息（出自于GB/T 35273-2017《信息安全技术 个人信息安全规范》）：指一旦泄露、非法提供或滥用可能危害人身和财产安全，极易导致个人名誉、身心健康受到损害或歧视性待遇相关的个人信息。例如，<b style="color: red;">财产信息（包括银行账号、鉴别信息（口令）、资金信息（包括资金数量、收益、余额）、交易和消费记录、流水记录、虚拟货币、虚拟交易、兑换码之类的虚拟财产信息））、个人生物识别信息（包括指纹、面部特征）、个人身份信息（包括身份证信息）、网络身份识别信息（包括系统账号、邮箱地址以及与前述有关的密码、口令、口令保护答案、用户个人数字证书）、其他信息（包括通讯录信息、个人电话号码、精准定位信息、收货地址、网页浏览记录）</b>。我们实际具体收集的个人敏感信息种类以下文描述为准。相比其他个人信息，个人敏感信息可能对您的个人权益影响更大。我们在此善意的提醒您需在谨慎考虑后再向我们提供您的个人敏感信息；若您同意提供您的个人敏感信息的，则意味着您同意您的个人敏感信息按本政策所述的目的和方式来处理。
<br>4. 设备：指可用于访问我们的产品、技术及/或服务的装置，例如台式计算机、笔记本电脑、平板电脑或智能手机。
<br>5. 唯一设备标识符（专属 ID 或 UUID）：是指由设备制造商编入到设备中的一串字符，可用于以独有方式标识相应设备（例如手机的 IMEI 号）。
<br>6. 去标识化/匿名化处理：指对个人信息进行技术处理，使得个人信息主体无法被识别，且处理后的信息不能被复原。
<br>7. 删除：指在实现日常业务功能所涉及的系统中去除个人信息的行为，使其保持不可被检索、访问的状态。
<br>8. <b style="color: red;">常见个人敏感信息包括但不限于如身份证号码、面部识别特征、银行账号、网页浏览信息、不满十四周岁未成年人的个人信息等，应用存在收集用户的个人信息或权限的行为（应用集成的[快手联盟（Android）] SDK获取用户信息：陀螺仪传感器,加速度传感器,重力传感器,MAC地址,ANDROID ID）</b>
<br>二、我们如何收集和使用您的个人信息
<br>A、我们收集哪些信息
<br>为了帮助您使用我们的产品、技术及/或服务，或成为我们的注册用户和会员；同时，也为了更好地向您提供内容搜索、浏览、上传、播放、推广相关服务，为您提供更好、更优的服务，我们将根据您使用的服务，收集和/或使用您的相关个人信息。这些信息可大致分为两类：第一类：为实现我们的产品、技术及/或服务的核心业务功能所必需的信息：此类信息是产品、技术及/或服务正常运行的必备信息，如您拒绝提供，您将无法正常使用我们的产品、技术及/或服务，因而，如您需要使用我们的产品、技术及/或服务的，则您需要授权我们收集和/或使用；第二类：附加业务功能可能需要收集的信息：此信息为非核心业务功能所需的信息，您可以选择是否授权我们收集。如您拒绝提供，将导致附加业务功能无法实现或无法达到我们拟达到的效果，但不影响您对核心业务功能的正常使用。您提供的个人信息具体属于哪类信息，可能因您使用的不同产品而有所区别，因而需以产品/服务的实际情况为准。 此外，我们会不断改进我们的产品、技术和/或服务，这意味着我们可能会经常推出新的业务功能，可能需要收集新的个人信息或变更个人信息使用目的或方式；如果此种情形发生的，我们会通过更新本政策、页面提示、站内信、弹窗、网站公告方式另行向您说明该信息收集的目的、内容、使用方式和范围，并为您提供自主选择同意的方式，且在征得您同意后收集。在此过程中，如果您对相关事宜有任何疑惑的，可以通过本政策第九条“如何联系我们”提供的方式联系我们，我们会尽快为您做出解答。 就您的个人信息的具体收集/提供方式及情况，可以按以下类型归纳：
<br>1. 您在使用我们的产品、技术及/或服务时主动提供的信息：例如，您在注册时填写的手机号码、昵称；您在用微信/QQ之类的第三方账号登录时关联到的微信号/QQ号；您在完善账号信息时上传的头像、照片；您参与我们线上活动、客服活动（如有）时填写的调查问卷中可能包含的您的姓名、电话、家庭地址。若您主动向我们提供您的个人敏感信息，即表示您同意我们按本政策所述目的和方式来处理您的个人敏感信息。
<br>2. 我们在您使用服务时获取的信息：当您使用我们的服务时，我们可能会自动收集并存储为服务日志的相关信息，具体可能为设备信息（例如：设备型号、操作系统版本、唯一设备标识符）、软件信息（例如：软件的版本号）、IP地址、服务日志信息（例如，您在使用我们服务时搜索、查看的信息、服务故障信息、引荐网址）；在您使用服务时，我们可能会通过IP地址或操作系统的位置服务获取您的地理位置信息）、从第三方合作伙伴获取的信息（我们可能会获得您在使用第三方合作伙伴服务时所产生或分享的信息。例如，您使用微信/QQ号登录时，我们会获得您的微信/QQ号昵称、头像、登录时间信息）。
<br>B、我们如何使用信息
<br>我们可能在以下业务场景下，收集或使用您的以下信息:
<br>1. 在您注册成为店玖盟的用户时
<br>当您在店玖盟客户端注册成为相关角色时(包括普通用户、会员及主播，以下统称“用户”)，您需要按照我们的指引完成一系列注册的程序，此后，我们将为您提供专属于注册用户的产品、技术及/或服务。在此过程中，您需要提供给我们一些单独或者结合识别您的用户身份的信息，包括:手机号码、验证码匹配结果，并创建账号 UID、密码。我们收集这些信息是用以完成注册程序、为您持续稳定提供服务，并保护您注册账号的安全。您应知悉，手机号码和验证码匹配结果属于您的个人敏感信息，我们收集该类信息是为了满足相关法律法规的要求，如您拒绝提供可能导致您无法使用我们的此功能。同时，您也可以在注册 时或后续使用过程中填写或补充您的性别、昵称、头像、生日、个人简介信息，如您未填写或后续删除、变更此类信息的，但不会影响相关用 户、会员、主播功能的正常使用。 DK存在收集IMEI、设备MAC地址和软件安装列表、通讯录和短信的行为
需要说明的是，我们支持您使用第三方平台的账号进行登录，如您使用第三方平台的账号登录的，我们将根据您的授权获取该第三方账号下的相关信息(包括:用户名、昵称、 头像，具体以您的授权内容为准)以及身份验证信息(个人敏感信息)。我们收集这些信息是用于为您提供账号登录服务以及保障您的账号安全，防范安全风险。如您拒绝授权此类 信息的，您将无法使用第三方平台的账号登录我们平台，但不影响我们为您提供的其他产品 和服务的正常使用。
<br>1. 当您使用视频展示、播放、下载、缓存功能时
<br>我们的产品、技术及/或服务为您提供视频展示和播放服务，在此过程中，我们需要收集您的一些信息，例如:设备型号、设备名称、设备唯一标识符、操作系统和应用程序版 本、登录 IP 地址、接入网络的方式、网络质量数据、移动网络信息(包括运营商名称)、 产品版本号、日志信息(如操作日志、服务日志)、音量大小调节信息。同时为了收集上 述基本的个人设备信息，我们将会申请访问您的设备信息和设备联网的权限;部分设备可能会因手机厂商的设置原因，附随联网权限共同发起发送短信、彩信的权限，这取决于您使用的是何种设备。我们收集这些信息是为了向您提供我们最核心的音频展示和播放服务， 如您拒绝提供上述权限将可能导致您无法使用我们的产品、技术及/或服务。 同时，我们的技术为您实现部分视频的下载、缓存功能，并且，您可以通过蓝牙连接硬件设备的方式，在车载音响上播放音频，在此过程中，我们需要收集您的一些信息，例如: 设备存储空间、蓝牙设备信息。为此，我们将会申请访问您的设备存储空间或对您本地缓存数据存储及读取;您需要连接硬件的，我们将会申请访问您的蓝牙设备权限。您可以随时通过相关功能设置开启/取消该权限。您开启该权限即视为您授权我们可以访问、获取、 收集、使用您的该等个人信息;当您取消该授权后，我们将不再收集该信息，也无法再为您 提供上述与之对应的服务;但除非您依照法律的规定删除了您的个人信息，否则您的取消行 为不会影响我们基于您之前的授权进行的个人信息的处理、存储。
<br>1. 当您使用扫描二维码、拍摄照片功能时
<br>当您使用扫描二维码、拍摄照片、拍摄视音频功能时，我们将访问您的设备相机、摄像头、麦克风相关权限，并收集您提供的基于扫描二维码、拍摄照片后向我们上传的图片、视音频信息(个人信息)，可能用于扫一扫、头像上传功能的实现。如您拒绝提供权限和内容的仅会 使您无法使用该功能，但并不影响您正常使用其他功能。同时，您也可以随时通过相关功能 设置开启/取消该权限。您开启该权限即视为您授权我们可以访问、获取、收集、使用您的 该等个人信息;当您取消该授权后，我们将不再收集该信息，也无法再为您提供上述与之对 应的服务;但除非您依照法律的规定删除了您的个人信息，否则您的取消行为不会影响我们 基于您之前的授权进行的个人信息的处理、存储。
<br>1. 当您购买产品或服务、进行付款时
<br>当您在我们平台购买产品或服务的，您需要提供一些下单与完成交易所需要的信息，包括:交易商品或服务信息;如果您购买的是实物商品的，您还需要提供收货人信息(收货人姓名、收货地址及其联系电话)(个人敏感信息)，此外，我们也可能会再收集一些其 他与订单相关的信息，包括:订单号、交易金额、下单时间、订单商户、订单编号、订单 状态、支付方式、支付账号、支付状态(个人敏感信息)，我们收集这些信息是为了帮助您顺利完成交易、保障您的交易安全、查询订单信息、提供客户服务。在您付款时，支付宝 SDK 会读取您的 IMEI 信息;在您成功下单后，如商品系第三方卖家提供的或商品需要第三方配送的，我们为了顺利、安全、准确向您完成货物的交付及配送，商家及第三方配送公司在发货及配送环节内不可避免地会获知您的相关配送信息(个人信息)。我们向您承诺，我们会以最大努力保障您的个人信息安全，我们会严格要求商家及第三方配送公司对您的个人信息保密，只以配送之目的获悉和使用，不得对外泄露或做其他任何用途。
<br>1. 当您使用客服、其他用户响应功能时
<br>当您联系我们的客服或使用其他用户响应功能时(包括:提出我们的产品、技术及/或服务的售后申请、行使您的相关个人信息控制权、其他客户投诉和需求)，为了您的账号与 系统安全，我们可能需要您先行提供账号信息，并与您之前的个人信息相匹配以验证您的用户身份。在您使用客服或其他用户响应功能时，我们可能还会需要收集您的如下个人敏感信息:联系方式(您与我们联系时使用的电话号码/电子邮箱或您向我们主动提供的其他联系方式)、您与我们的沟通信息(包括文字/图片/视音频/通话记录形式)、与您需求相关联的其他必要信息。我们收集这些信息是为了调查事实与帮助您解决问题，如您拒绝提供可能导致您无法使用我们的客服之类用户响应机制。
<br>1. 其他需要收集或使用您的信息的场景
<br>(1) 我们为保障账号安全功能所需
<br>我们需要收集您的一些信息来保障您使用我们的产品、技术及/或服务时的账号与系统安全，并协助提升我们的产品与/服务的安全性和可靠性，以防产生任何危害用户、我们及 关联公司、社会的行为，包括:您的如下个人信息:账号登录地、个人常用设备信息、登录 IP 地址、产品版本号、网络使用习惯、服务故障信息，以及个人敏感信息:交易信息、 实名认证信息(在您进行实名制认证时会获取，包括真实姓名、身份证号、身份证照片)。 我们会根据上述信息来综合判断您账号、账户及交易风险、进行身份验证、客户服务、检测 及防范安全事件、诈骗监测、存档和备份用途，并依法采取必要的记录、审计、分析、处置 措施，一旦我们检测出存在或疑似存在账号安全风险时，我们会使用相关信息进行安全验证 与风险排除，确保我们向您提供的产品和服务的安全性，以用来保障您的权益不受侵害。同 时，当发生账号或系统安全问题时，我们会收集这些信息来优化我们的产品和服务。
<br>(2) 我们为与外部第三方共同服务于您所需
<br>您知悉，您向外部第三方提供的个人信息，或外部第三方收集的您的个人信息，我们无法获取，更不会使用非常规方式擅自以软件程序获得您的个人信息。如果因业务发展的必要 而需要从第三方间接收集(如共享)您的个人信息的，且由我们直接或联合为您提供产品或服务的，我们(或第三方)在收集前会向您明示共享的您个人信息的来源、类型、使用目的、 方式和所用于的业务功能、授权同意范围(如果使用方式和范围超出您在第三方原授权范围 的，我们会再次征得您的授权同意)，此种场景包括您通过第三方账户直接登录我们的产品、 技术及/或服务时，我们从第三方获取的您授权共享的账户信息(包括头像、昵称)、我们 的某些产品/服务由业务合作伙伴提供或者我们与业务合作伙伴共同提供时，为了必要/合理 的业务的顺利开展，我们从部分业务合作伙伴处间接收集的您的部分信息、其他方使用我们 的产品、技术及/或服务时所提供有关您的信息(包括发布的与您相关的内容，包括评论、 动态、图片、照片、视音频)。
<br>我们会使用不低于我们对自身用户个人信息同等的保护手段与措施对间接获取的个人 信息进行保护。
<br>1. 其他
<br>如上文所述，如果某一需要收集您的个人信息的功能或产品/服务未能在本政策中予以说明的，或者我们超出了与收集您的个人信息时所声称的目的及具有直接或合理关联范围 的，我们将在收集和使用你的个人信息前，通过更新本政策、页面提示、弹窗、消息通知、 网站公告、站内信或其他便于您获知的方式另行向您说明，并为您提供自主选择同意的方式，且在征得您明示同意后收集和使用。
<br>1. 权限的开启及取消路径
<br>对于上文中提及的针对特定业务场景的权限，您可以随时通过相关功能设置开启/取消该权限的授权。以“手机端店玖盟APP”为例，当前，权限开启路径为:(1)在您申请 使用某项业务功能时，向您弹出授权询问页面，您确认后开启该项权限;(2)您自行进入 设备的隐私及权限管理页面，开启相应权限。拒绝授权、取消授权或关闭权限的路径为:(1) 在您申请使用某项业务功能时，您不予确认授权询问页面;(2)您自行进入设备的隐私及 权限管理页面，将已经授权的权限进行关闭。就具体路径而言，IOS 系统默认的权限设置路径为:设置—应用列表—店玖盟，找到店玖盟 应用后点击进入应用信息页面，可以在信 息页查看店玖盟 目前开启的权限，可以选择关闭任意一个权限。
<br>再次地，您理解并同意，您开启该权限即视为您授权我们可以访问、获取、收集、使用 您的该等个人信息;但当您取消该授权后，我们将不再收集该信息，也无法再为您提供上述 与之对应的服务;但除非您依照法律的规定删除了您的个人信息，否则您的取消行为不会影 响我们基于您之前的授权进行的个人信息的处理、存储。
<br>1. 例外情形
<br>另外，您充分理解并同意，我们在以下情况下收集、使用您的个人信息无需您的授权同意:
<br>(1)与国家安全、国防安全直接相关的;(2)与公共安全、公共卫生、重大公共利益直接相关的;(3)与犯罪侦查、起诉、审判和判决执行或其他直接相关的;或根据法律法规 的要求、行政机关或公检法或其他有权机关的要求的;(4)出于维护您或其他个人的生命、 财产或其他重大合法权益但又很难得到您本人同意的;(5)所收集的信息是您自行向社会 公开的或者是从合法公开的渠道(如合法的新闻报道、政府信息公开或其他渠道)中收集到 的;(6)根据与您签订和履行相关协议或其他书面文件所必需的;(7)用于维护我们的 产品、技术及/或服务的安全稳定运行所必需的，例如发现、处置产品、技术及/或服务的故障;(8)法律法规规定的其他情形。
<br>三、我们如何使用 Cookie 和同类技术
<br>A、什么是 Cookie 和同类技术
<br>Cookie 是包含字符串的小文本文件，在您浏览、使用网站或其他网络内容时，存放在您所使用的网站服务器客户端(您的计算机、移动电话或其他智能终端内)里面，通常会经过加密，可用于改善您的使用体验。Cookie 同类技术是可用于与 Cookie 类似用途的其他技 术，例如:Web Beacon、Proxy、嵌入式脚本、浏览器本地存储。目前，我们主要使用 Cookie 收集您的个人信息。您知悉并同意，随着技术的发展和我们产品、技术及/或服务的进一步 完善，我们也可能会使用 Cookie 同类技术。
<br>B、我们如何使用 Cookie 和同类技术
<br>在您使用我们的产品、技术及/或服务时，我们可能会通过 Cookie 或同类技术收集您的一些个人信息，请您理解，我们的某些服务只能通过使用“Cookie”才可得到实现。如果您的浏览器或 浏览器附加服务允许，您可以修改对 Cookie 的接受程度或者(部分/全部)拒绝 Cookie 及/或同类技术，但您需理解并知悉:这一举动在某些情况下可能会影响您正常使用我们的产 品、技术和/或服务，或无法获得最佳的服务体验，同时也可能会对您的信息保护和账号安 全性造成一定的影响。
<br>四、我们如何共享、转让、公开披露您的个人信息
<br>A、共享和披露
<br>请您理解，我们高度重视对您的个人信息的保护，对于您的个人信息，我们仅在本政策所述目的和范围内或根据法律法规的要求收集和使用，并进行严格保密;我们不会与任何第 三方共享您的个人信息，除非存在以下一种或多种情形:
<br>1. 在获得您的明确同意或授权或您主动选择的情况下共享:获得您的授权或明确同意后，我们会与其他公司、组织和个人分享您的个人信息。例如，如果我们委托第三方向您提 供产品或服务(如用户活动、抽奖奖品寄送、积分兑换奖品时)，我们会在征得您同意 后将上述信息共享给第三方，如果您拒绝提供此类信息，我们将无法完成相关交付服务。 只有您选择同意，我们才会共享您的个人敏感信息。获得您明确同意或基于您的主动 选择，我们可能会公开披露您的个人信息。
<br>2. 在法定情形下的共享和披露。我们可能会根据法律法规规定、诉讼争议解决需要，或按行政、司法机关依法提出的要求，对外共享您的个人信息。例如如果我们确定您出现违反法律法规或严重违反平台相关协议规则的情况，或为保护平台网站及关联公司用 户或公众的人身财产安全免遭侵害，我们可能依据法律法规或平台相关协议规则征得您 同意的情况下披露关于您的个人信息，包括相关违规行为以及平台已对您采取的措施。 例如，若您或您使用的账号上传非法音频、违规音频而严重违反平台规则、触犯法律法规和/或违背公序良俗，造成重大社会影响，给平台造成声誉损失，我们可能会披露您 的信息与处罚情况。
<br>3. 与部分授权合作伙伴进行必要的共享。我们会委托授权合作伙伴为您提供某些服务或代表我们履行职能，我们仅会出于合法、正当、必要、特定、明确的目的共享您的信息，并会与之签署保密协议，要求合作伙伴按照我们的说明、本政策以及其他任何相关的保密和安全措施来处理个人信息。授权合作伙伴只能接触到其为履行职责所必须 的一些信息，且不能将此信息用于任何其他目的。如果我们共享您的个人敏感信息或 改变个人信息的使用及处理目的，将再次征求您的授权同意。目前，我们的授权合作 伙伴包括以下类型:
<br>(1) 广告、分析服务类的授权合作伙伴：除非得到您的授权许可，否则我们不会将您的个人身份信息（指可以识别您身份的信息，例如姓名或电子邮箱，通过这些信息可以联系到您或识别您的身份）与提供广告、分析服务的合作伙伴共享。统计分析类以及平台反作弊的授权合作伙伴包括秒针、友盟、数盟、艾瑞。
<br>(2) 供应商、服务提供商和其他合作伙伴：例如，相关牌照方、电信运营商、其他。这些支持包括提供技术基础设施服务、分析我们服务的使用方式、衡量广告和服务的有效性、提供客户服务、支付便利或进行学术研究和调查。例如，为实现一键登录功能，我们可能将您的必要信息提供一键登录服务的提供商（例如：中国联通、中国移动、中国电信、微信、微博、百度、腾讯QQ）；为实现您购买产品或服务的需求（包括享受售后服务），我们可能将您的订单信息与交易相关的信息共享给我们平台的第三方商家或版权方（例如：客户售后服务的授权合作伙伴包括Udesk）。
<br>(3) 第三方插件、SDK类服务商：
<br>我们产品中可能会包含第三方SDK或其他类似的应用程序，如您在我们平台上使用这类由第三方提供的服务时，您同意将由其直接收集和处理您的信息（如以嵌入代码、插件或其他形式），例如：如您使用华为手机的，华为Push SDK需要读取您的IMEI信息，用于推送/下发通知栏消息；如您使用支付宝付款的，为了让您完成交易、实现交易目的，支付宝SDK需要读取您的IMEI信息；在个别应用市场，如果您使用移动支付的，移动SDK在经过您的授权许可后，需要访问您的发送、读取、修改短信权限；为实现跨应用打开店玖盟并完成页面还原功能，我们会共享设备信息、网络信息给服务提供商（例如：lkme.cc/北京微方程科技有限公司），用于实现打开应用并完成目标页面定位。前述服务商收集和处理信息行为遵守其自身的隐私条款，而不适用于本政策。但我们也会努力审查该第三方的业务准入资质并努力要求该等服务商的合法合规性与安全性。为了最大程度保障您的信息安全，我们强烈建议您在使用任何第三方SDK类服务前先行查看其隐私条款。为保障您的合法权益，如您发现此类SDK或其他类似的应用程序存在风险时，建议您立即终止相关操作并及时与我们取得联系。
<br>1. 为处理争议或纠纷而进行的必要披露。如您是适格的知识产权投诉人并已提起投诉， 我们可能应被投诉人要求，向其披露您的一些信息，以便双方处理可能的权利纠纷;如您因涉嫌侵权而被投诉，我们可能应投诉人或司法机关、行政执法部门的要求，向其披 露您的一些信息。
<br>2. 有权机关的要求、法律法规规定、我们与您的相关协议约定的其他情形。
<br>您可以基于店玖盟平台的分享功能或页面信息与第三人(包括不特定对象)共享您的个人信息或其他信息，但因您自发的共享行为而导致的信息泄露、被使用情况，与我们无关，您需要自行承担相应的法律责任。
<br>我们仅会出于合法、正当、必要、特定、明确的目的共享您的个人信息，并且只会共享必要的个人信息。在我们与业务合作伙伴共享信息时，我们会以多种方式保护您的个人信息，并且，即使已经取得您的授权同意，我们也仅会出于合法、正当、必要、特定、明确的 目的共享您的个人信息。我们会尽可能对共享内容中的个人信息进行去标识化处理。请您理解并知悉，如果信息经过去标识化或匿名化处理的，则处理后的信息无法指向与识别您， 实际上已不属于您的个人信息，其共享无需征得您的授权同意。
<br>B、转让
<br>转让是指将个人信息控制权向其他公司、组织或个人转移的过程。原则上我们不会将您的个人信息转让，但以下情况除外:(1)事先已获得您的明确授权同意;(2)如我们进 行兼并、收购、重组、分立、破产、资产转让或类似的交易，而您的个人信息有可能作为此类交易的一部分而被转移，我们会要求新持有人继续遵守和履行本政策的全部内容(包括使 用目的、使用规则、安全保护措施)，否则我们将要求其重新获取您的明示授权同意;(3) 法律法规规定的其他情形。 我们会尽可能在转让前向您告知转让的信息的目的、类型(如涉及您的个人敏感信息的， 我们还会向您告知涉及的敏感信息的内容)，并在征得您的授权同意后再转让，但法律法规另有规定的或本政策另有约定的除外。
<br>C、公开披露
<br>公开披露是指向社会或不特定人群发布信息的行为。除了因需要对违规账号、欺诈行为或相关行为进行处罚公告、公布中奖/获胜者名单时脱敏展示相关信息或其他必要事宜而进行的必要披露外，我们不会对您的个人信息进行公开披露，如具备合理事由确需公开披露的， 我们会在公开披露前向您告知公开披露的信息的目的、类型(如涉及您的个人敏感信息的， 我们还会向您告知涉及的敏感信息的内容)，并在征得您的授权同意后再公开披露，但法 律法规另有规定的或本政策另有约定的除外。 对于公开披露的您的个人信息，我们会充分重视风险，在收到公开披露申请后第一时间且审慎审查其正当性、合理性、合法性，并在公开披露时和公开披露后采取不低于本政策约 定的个人信息安全保护措施和手段的程度对其进行保护。
<br>请您知悉，即使已经取得您的授权同意，我们也仅会出于合法、正当、必要、特定、明确的目的公开披露您的个人信息，并尽量对公开披露内容中的个人信息进行去标识化处理。 请您理解并知悉，如果信息经过去标识化或匿名化处理的，则处理后的信息无法指向与识别您，实际上已不属于您的个人信息，其共享无需征得您的授权同意。
<br>D、例外情形
<br>根据法律法规规定，在下述情况下，共享、转让、公开披露您的个人信息无需事先征得您的授权同意:(1)与国家安全、国防安全直接相关的;(2)与公共安全、公共卫生、 重大公共利益直接相关的;(3)与犯罪侦查、起诉、审判和判决执行直接相关的;或根据 法律法规的要求、行政机关或公检法或其他有权机关的要求的;(4)出于维护您或其他个 人的生命、财产或其他重大合法权益但又很难得到您本人同意的;(5)个人信息是您自行 向社会公开的或者是从合法公开的渠道(如合法的新闻报道、政府信息公开或其他渠道)中 收集到的;(6)根据与您签订和履行相关协议或其他书面文件所必需的;(7)法律法规 规定的其他情形。
<br>E、共享、转让、公开披露的相关责任
<br>我们将严格按照本政策的约定及相关法律法规的要求执行对个人信息的共享、转让、公开披露的操作，如因我们的过错原因导致您的合法权益遭受损害的，我们愿意就我们的过错 在法律规定的范围内向您承担相应的损害赔偿责任。
<br>五、您对个人信息享有的控制权
<br>A、访问、更新和删除
<br>我们鼓励您更新和修改您的信息，以使其更准确有效。您可以通过我们的服务来访问您的信息，并根据对应信息的管理方式自行完成或要求我们帮助完成进行修改、补充和删除。我们将采取适当的技术手段或提供提交申请的联系渠道，尽可能保证您可以访问、更新和更 正自己的信息或使用我们的服务时提供的其他信息。
<br>在访问、更新、更正和删除前述信息时，我们可能会要求您进行身份验证，以保障信息安全。如您想访问、修改或删除您的部分信息，请登录您的店玖盟 账号，按照具体指引进 行操作。
<br>B、公开与分享
<br>我们的产品、技术及/或服务可让您不仅与您的社交网络、也与使用该服务的其他用户公开分享您的相关信息，例如，您在店玖盟平台所上传或发布的内容或信息、您对其他人上传或发布的内容或信息做出的评论或回应，您在用户社区/社群可见的公开区域内上传或 公布您的信息，以及包括与这些信息有关的位置数据和日志信息。只要您不删除您所公开或共享的信息，有关信息可能一直留存在特定公众领域;即使您删除共享信息，有关信息仍 可能由其他用户或不受我们控制的第三方独立地缓存、复制或储存，或由其他用户或相关第三方在公众领域保存。如您将信息通过上述渠道公开或共享，由此造成您的信息泄露，我们不承担责任。因此，我们善意提醒并请您慎重考虑是否通过上述渠道公开或共享您的信息。
<br>C、注销
<br>我们为您提供店玖盟账号注销权限，您可以通过在线申请注销或联系我们的客服或通过其他我们公示的方式注销您的账号(但法律法规另有规定的或本政策另有约定的除外)， 一旦您注销账号，将无法使用我们提供的全线产品的服务且自动放弃已有的权益，因此请您谨慎操作。除法律法规另有规定外，注销账号之后，我们将停止为您提供我们所有的产品 和服务，您曾通过该账号使用的我们的产品与服务下的所有内容、信息、数据、记录将会被 删除或匿名化处理。
<br>如您在谨慎考虑后仍执意决定注销您的店玖盟账号的，您可以在您相关功能设置页面或根据操作指引向我们提交注销申请，以“手机端店玖盟APP”为例，其中的账号注销路径为：个人中心—设置—账号和绑定设置—注销。
<br>D、改变您授权同意的范围
<br>您可以选择是否披露信息。有些信息是使用我们的服务所必需的，但大多数其他信息的提供是由您决定是否授权的。您可以通过删除信息、关闭设备功能方式改变您授权我们继续收集信息的范围或撤回您的授权。您撤回授权的决定，不会影响此前基于您的授权而开展的信息收集及处理。
<br>E、提前获知产品、技术及/或服务停止运营权
<br>我们将持续为您提供优质服务，若因特殊原因导致我们的部分或全部产品、技术及/或 服务被迫停止运营，我们将提前在显著位置或向您发送推送消息或以站内信或其他方式通知 您，并将停止对您个人信息的收集。
<br>F、获得帮助反馈的权利
<br>我们为您提供了多种反馈渠道，具体请见本政策第九条“如何联系我们”章节。
<br>六、我们如何存储您的个人信息
<br>A、存储地点
<br>我们依照法律法规的规定，将您的个人信息存储于中华人民共和国境内。目前我们暂时不存在跨境存储您的个人信息或向境外提供个人信息的场景。如需跨境存储或向境外提 供个人信息的，我们会单独向您明确告知(包括出境的目的、接收方、使用方式与范围、使 用内容、安全保障措施、安全风险)并再次征得您的授权同意。
<br>B、存储期限
<br>我们在为提供我们的产品和服务之目的所必需且最短的期间内保留您的个人信息，例 如:当您成为我们的注册用户时，我们需要收集您的手机号码，且在您提供后并在您使用该 功能期间，我们需要持续为您保持您的手机号码，以向您正常提供该功能、保障您的账号和 系统安全。如果您申请注销账号的，我们会对您的个人信息进行删除或匿名化处理。
<br>七、我们如何保护您的个人信息
<br>保护用户个人信息的安全是我们的一项基本原则，我们高度重视，并希望确保依据本政 策及国家法律法规要求，对您的信息提供足够的保护。我们成立了专门的数据安全团队，并 采取一切合理可行的措施，保护您的信息:
<br>A、数据安全技术措施
<br>我们会采用符合业界标准的安全防护措施，包括建立合理的制度规范、安全技术来防止 您的信息遭到未经授权的访问使用、修改，避免数据的损坏或丢失。网络服务采取了多种加 密技术，例如在某些服务中，我们将利用加密技术(例如 SSL)来保护您的信息，采取加 密技术对您的信息进行加密保存，并通过隔离技术进行隔离。在信息使用时，例如信息展示、 信息关联计算，我们会采用多种数据脱敏技术增强信息在使用中安全性。采用严格的数据访 问权限控制和多重身份认证技术保护信息，避免数据被违规使用。
<br>B、数据安全管理措施
<br>我们通过建立数据分类分级制度、数据安全管理规范、数据安全开发规范来管理规范信 息的存储和使用。我们通过信息接触者保密协议、监控和审计机制来对数据进行全面安全控 制。加强安全意识。我们还会举办安全和隐私保护培训课程，加强员工对于保护信息重要性 的认识。
<br>C、协议安全保障措施
<br>我们仅允许有必要知晓这些信息的员工或合作伙伴访问您的信息，并为此设置了严格的 访问权限控制和监控机制。我们同时要求可能接触到您的信息的所有人员履行相应的保密义务。如果相关人员或合作伙伴未能履行这些义务，可能会被追究法律责任或被中止与店玖盟 的合作关系。
<br>D、安全事件处置
<br>在通过我们的产品、技术及/或服务与第三方进行沟通或购买产品及服务时，如果您不可避免的要向交易对方或潜在的交易对方披露自己的信息，如联络方式或者邮政地址。请您 妥善保护自己的信息，仅在必要的情形下向他人提供。
为应对信息泄露、损毁和丢失之类的可能出现的风险，我们制定了多项制度，明确安全 事件、安全漏洞的分类分级标准及相应的处理流程。我们也为安全事件建立了专门的应急响 应团队，按照安全事件处置规范要求，针对不同安全事件启动安全预案，进行止损、分析、 定位、制定补救措施、联合相关部门进行溯源和打击。
请您理解，由于技术的限制以及风险防范的局限，即便我们已经尽量加强安全措施，也 无法始终保证信息百分之百的安全。因此，我们善意地提请您的注意，您接入我们的服务 时所使用的系统和通讯网络，也均有可能因我们可控范围外的情况而发生问题。
在不幸发生信息安全事件后，我们将按照法律法规的要求，及时向您告知:安全事件的基本情况和可能的影响、我们已采取或将要采取的处置措施、您可自主防范和降低风险的建议、对您的补救措施。我们同时将及时将事件相关情况告知您，难以逐一告知信息主体时， 我们会采取合理、有效的方式发布公告或站内信。同时，我们还将按照监管部门要求，主动 上报信息安全事件的处置情况。
请您知悉并理解，互联网并非绝对安全的环境，我们强烈建议您通过安全方式、使用复杂密码，协助我们保证您的账号安全。如您发现自己的个人信息泄密，尤其是您的账户 或密码发生泄露，请您立即根据本隐私政策文末中提供的联系方式联络我们，以便我们采取相应措施来保护您的信息安全。
<br>八、未成年人保护
<br>A、未成年人个人信息保护规则
<br>我们非常注重对未成年人的保护，致力于践行我们的企业社会责任。未成年人使用我们的产品、技术及/或服务之前应首先取得其监护人的同意。如您为未成年人，在使用我们的产品、技术及/或服务前，应在监护人监护、指导下共同阅读本政策，且应在监护人明确同意和指导下使用我们的产品、技术及/或服务、提交个人信息。我们根据国家相关法律法规的规定保护未成年人的个人信息，只会在法律法规允许、监护人明确同意或保护您的权益所必要的情况下收集、使用或公开披露未成年人的个人信息；若您是未成年人的监护人，当您对您所监护的未成年人的个人信息有相关疑问时，请通过本政策第十条“如何联系我们”章节中的联系方式与我们联系。如果我们发现在未事先获得可证实的监护人同意的情况下收集了未成年人的个人信息，则会设法尽快删除相关数据。
<br>B、儿童个人信息保护规则（专门条款，请监护人仔细阅读，以下称“本规则”）
<br>本规则为儿童个人信息保护的专门规则，旨在更详细的向儿童监护人和儿童说明我们如何收集、使用、存储和处理儿童个人信息，以及我们为监护人与儿童提供的访问、更正、删除、保护这些信息的方式。如果您是儿童用户的监护人，请您仔细阅读、充分理解本规则，以及确定您是否同意您和您监护的儿童使用我们的特定产品、技术和/或服务（指在本规则适用范围内的产品、技术和/或服务）
<br>九、关于我们及如何联系我们
<br>店玖盟是店玖盟。如您想更详细的了解我们的公司、平台，您可以通过本政策提供的联 系方式与我们联系。我们经营主体之一信息如下:公司名称:店玖盟; 注册地址: 安徽省滁州市来安县汉河镇高新路1号(金太阳商业综合体)商业(公寓)1315铺。
<br> 如您对本政策的执行或使用我们的产品、技术及/或服务时遇到的与隐私保护相 关的事宜有任何问题(包括问题咨询、投诉)，我们专门为您提供了多种反馈通道，希望为您提供满意的解决方案:(1)在线客服/其他在线意见反馈通道:您可与我们平台上产品功 能页面的在线客服联系或者在线提交意见反馈;(2)人工客服通道:您可以拨打我们的客服电话与我们联系，客服电话为: 18914473326
<br>;(3) 邮箱：【xbw-178455424】您可以通过以下任一邮 箱与我们联系。
<br>(二)我们会在收到您的意见及建议，并在验证您用户身份后的15天内尽快向您回复。 但是，在以下情形下，您理解并知悉，我们将无法响应您的请求:(1)与国家安全、国防 安全有关的;(2)与公共安全、公共卫生、重大公共利益有关的;(3)与犯罪侦查、起 诉和审判有关的;(4)有充分证据表明您存在主观恶意或滥用权利的;(5)响应您的请 求将导致您或其他个人、组织的合法权益受到严重损害的;(6)涉及商业秘密的;(7) 法律法规规定的其他情形。
<br>(三)如果您对我们的回复不满意，或我们对您个人信息的处理方式侵害了您的合法权 益，且在您向我们反馈后我们仍拒绝改进的，您可以向工商或其他监管部门进行投诉、举报。
<br>十、其他
<br>(一)本政策的解释及争议解决均应适用中华人民共和国大陆地区法律。与政策相关 的任何纠纷，双方应协商友好解决;若不能协商解决，您同意将争议提交至四川省巴中市人民法院诉讼解决。
<br>(二)本政策的标题仅为方便及阅读而设，并不影响正文其中任何规定的含义或解释。
<br>十一、第三方SDK共享信息
<br>SDK名称： 数字天堂SDK
<br>包名信息： io.dcloud
<br>使用目的： 基础模块服务，应用运行期间需要收集设备唯一识别码（IMEI/android ID/DEVICE_ID/IDFA、SIM卡 IMSI信息、OAID）以供统计分析服务，并通过应用启动数据及异常错误日志分析改进性能和用户体验
<br>涉及个人信息： 存储的个人文件，设备信息（IMEI、MAC、ANDROID_ID、DEVICE_ID、IMSI），网络信息 设备传感器
<br>隐私权政策链接/官网： https://ask.dcloud.net.cn/protocol.html
<br>SDK名称阿里：weexSDK
<br>公司全称：数字天堂（北京）网络技术有限公司
<br>SDK用途：uni-app基础模块默认集成，用于渲染uniapp的nvue页面引擎
<br>获取的个人信息类型：存储的个人文件 设备weex
<br>调用的设备权限：读取外置存储器、写入外置存储器 收集设备weex 传感器
<br>共享的个人信息类型：手机号码、设备识别信息 传感器
<br>官网链接： http://doc.weex.io/zh
<br>SDK:极光推送cn.jiguang
<br>个人信息类型:个人常用设备信息、个人位置信息
<br>用途：消息推送
<br>应用场景:用于实现消息推送(或其他推送)功能，以及 App 一键登录号码认证的功能
<br>获取数据及目的：极光推送SDK获取手机IMSI、MAC、Android_ID、SIM序列号，获取运行中进程信息信息用来推送消息
<br>第三方机构名称:深圳市和讯华谷信息技术有限公司 https://docs.jiguang.cn/jpush/guideline/intro/
<br>第三方相关隐私政策:https://www.jiguang.cn/license/privacy
<br>
<br>阿里百川SDK
<br>包含：百川电商 appLink SDK、百川电商小程序SDK、百川电商webview容器、百川电商广告SDK、百川电商基础公共组件、阿里设备标识SDK、淘宝通道服务SDK
<br>所属公司：淘宝（中国）软件有限公司
<br>应用场景：用于淘宝/天猫授权，唤起手机淘宝App
<br>使用权限：访问电话状态、读取或写入系统设置、连接配对过的蓝牙设备、获取信息有关当前或最近运行的任务，一个缩略的任务状态，是否活动。
<br>隐私协议地址：
<br>https://terms.alicdn.com/legal-agreement/terms/suit_bu1_b2b/suit_bu1_b2b201703271337_94551.html
<br>
<br>. 京东SDK
<br>包含：京东CPS联盟SDK、京东开普勒SDK
<br>所属公司：北京京东叁佰陆拾度电子商务有限公司
<br>应用场景：用于唤起手机京东App
<br>使用权限：网络权限、读写WIFI状态、访问电话状态、获取网络信息状态，如当前的网络连接是否有效 、读写存储的权限
<br>隐私协议地址：
<br>https://about.jd.com/privacy/
<br>
<br>. MobTech SDK
<br>包含：ShareSDK、MobLink、SecVerify、SMSSDK、MobConnect SDK、MobPushSDK、MobTech秒验SDK、Mob哨兵APM SDK、MobCommons SDK、MobTools SDK
<br>所属公司：上海游昆信息技术有限公司
<br>应用场景：用于第三方分享、微信登录，场景还原，一键本机号码登录，发送短信等功能
<br>使用权限：iOS广告标识符（IDFA）、MAC地址、国际移动设备识别码（IMEI）、匿名设备标识符(OAID)、国际移动用户识别码（IMSI），定位信息，应用列表信息，社交平台OpenID，个人敏感信息手机号码，联系人权限，获取系统运营信息权限，获取网络状态信息权限，获取基站信息权限。
<br>隐私协议地址
<br>https://www.mob.com/about/policy
<br>
<br>（4）高德地图SDK
<br>所属公司：高德软件有限公司
<br>应用场景：用于在加油等功能获取当前位置
<br>使用权限：网络定位、GPS定位精准定位、网络状态、wifi权限进行网络定位、网络权限、电话状态、存储读写权限、申请调用A-GPS模块权限、前台服务权限、后台定位权限
<br>隐私协议地址
<br>http://cache.amap.com/h5/h5/publish/238/index.html
<br>
<br>（5）buglySDK
<br>所属公司：深圳市腾讯计算机系统有限公司
<br>应用场景：用于收集在软件使用过程中异常问题
<br>使用权限：电话状态、读取日志权限、网络权限、网络状态
<br>隐私协议地址
<br>https://privacy.qq.com/document/priview/fbd2c3f898df4c1c869925dd49d57827
<br>
<br>. 支付宝SDK
<br>包含：阿里安全功能SDK、阿里无线保镖SDK、阿里移动API网关SDK、阿里崩溃分析SDK
<br>所属公司：支付宝(中国)网络技术有限公司
<br>应用场景：用于支付宝支付
<br>使用权限：网络权限、Wifi状态权限、网络状态、电话状态
<br>隐私协议地址
<br>https://render.alipay.com/p/c/k2cx0tg8
<br>
<br>（7）微信OpenSDK
<br>所属公司：深圳市腾讯计算机系统有限公司
<br>应用场景：用于微信支付
<br>使用权限：网络权限、Wifi状态权限、网络状态、电话状态
<br>隐私协议地址
<br>https://weixin.qq.com/cgi-bin/readtemplate?t=weixin_agreement&s=privacy&cc=CN
<br>
<br>（8）穿山甲（pangle）SDK
<br>所属公司：北京巨量引擎网络技术有限公司
<br>应用场景：用于广告服务
<br>使用权限：电话状态、网络状态、文件读写、位置权限、手机屏幕关闭后后台进程仍然运行、获取应用列表
<br>隐私协议地址
<br>https://www.pangle.cn/privacy
<br>（9）优量汇SDK
<br>所属公司：深圳市腾讯计算机系统有限公司
<br>应用场景：用于广告服务
<br>使用权限：位置权限、精准定位权限、电话状态
<br>隐私协议地址
<br>https://imgcache.qq.com/gdt/cdn/adn/uniondoc/ylh_sdk_privacy_statement.html
<br>
<br>（10）快手SDK
<br>所属公司：北京快手科技有限公司
<br>应用场景：用于广告服务
<br>使用权限：联⽹权限、获取设备标识IMEI。⽤于标识⽤户、读写存储权限、获取MAC地址，⽤于标识⽤户、安装应⽤权限、定位权限
<br>隐私协议地址
<br>https://www.kuaishou.com/about/policy

<br>（11）华为SDK
<br>包含：华为update SDK、华为HMS核心功能SDK、华为log SDK、华为消息推送SDK、华为AppGallery Connect core SDK
<br>所属公司：华为技术有限公司
<br>应用场景：华为手机消息推送
<br>使用权限：读取储存权限、设备信息、消息通知、读取网络状态、读取WIFI状态、允许一个程序获取信息有关当前或最近运行的任务，一个缩略的任务状态，是否活动。
<br>隐私协议地址
<br>https://support.huaweicloud.com/index.html
<br>
<br>（12）魅族推送SDK
<br>所属公司：魅族科技有限公司
<br>应用场景：魅族手机消息推送
<br>使用权限：读取储存权限、设备信息、消息通知、读取网络状态、读取WIFI状态、允许一个程序获取信息有关当前或最近运行的任务，一个缩略的任务状态，是否活动。
<br>隐私协议地址
<br>https://i.flyme.cn/privacy?lang=zh_CN
<br>
<br>（13）小米开放平台消息推送SDK
<br>所属公司：小米科技有限责任公司
<br>应用场景：小米手机消息推送
<br>使用权限：读取储存权限、设备信息、消息通知、读取网络状态、读取WIFI状态、允许一个程序获取信息有关当前或最近运行的任务，一个缩略的任务状态，是否活动。
<br>隐私协议地址
<br>https://privacy.mi.com/all/zh_CN/
<br>
<br>（14）中国电信天翼号码认证SDK
<br>所属公司：中国电信集团有限公
<br>应用场景：一键登录，验证码获取、短信推送
<br>使用权限：设备信息、读取短信
<br>隐私协议地址
<br>https://id.189.cn/html/agreement_597.html
<br>
<br>（15）中国移动号码认证SDK
<br>所属公司：中国移动通信集团有限公司
<br>应用场景：一键登录，验证码获取、短信推送
<br>使用权限：设备信息、读取短信
<br>隐私协议地址
<br>https://wap.gd.10086.cn/wap2012/html/v2017/01/BR201701120013/choseNumber_sz14.shtml
<br>
<br>（16）微博开放平台SDK、微博SSO授权SDK
<br>所属公司：新浪
<br>应用场景：使用微博快速登录
<br>使用权限：存储权限、读取设备信息、读取网络状态、读取WIFI状态
<br>隐私协议地址
<br>https://weibo.com/signup/v5/privacy
<br>
<br>（17）OPPO推送平台SDK
<br>所属公司：OPPO 广东移动通信有限公司
<br>应用场景：oppo手机消息推送
<br>使用权限：读取储存权限、设备信息、消息通知、读取网络状态、读取WIFI状态、允许一个程序获取信息有关当前或最近运行的任务，一个缩略的任务状态，是否活动。
<br>隐私协议地址
<br>https://www.oppo.com/cn/privacy/
<br>
<br>（18）VIVO消息推送SDK
<br>所属公司：维沃移动通信有限公司
<br>应用场景：VIVO手机消息推送
<br>使用权限：读取储存权限、设备信息、消息通知、读取网络状态、读取WIFI状态、允许一个程序获取信息有关当前或最近运行的任务，一个缩略的任务状态，是否活动。
<br>隐私协议地址
<br>https://www.vivo.com.cn/about-vivo/privacy-policy
<br>
<br>（19）谷歌SDK
<br>包含：ExoPlayer、Gson、Guava、flutter
<br>所属公司：谷歌公司
<br>应用场景：制作用户使用界面
<br>使用权限：
<br>隐私协议地址
<br>https://www.google.cn/policies/terms/archive/20070416/
<br>
<br>（20）OKHttp SDK
<br>包含：Okio、OkHttp、hongyangAndroid okhttputils
<br>应用场景：为了提升网络使用效率
<br>使用权限：网络数据
<br>
<br>（21）Android SDK
<br>包含：Android Lifecycle ViewModel、Android Support Library Fragment、Android Support Library Compat、Android Support Library V4
<br>所属公司：谷歌公司
<br>应用场景：为了兼容Android不同版本，提供更多新版系统组件、用户界面交互及数据访问帮助。
<br>使用权限：储存空间
<br>
<br>（22）底层系统SDK
<br>包含：JSON In Java、JetBrains Java Annotations、uCrop、
<br>使用场景：用于编写应用基础组
<br>
<br>
        </div>
      </el-col>
    </el-row>
  </div> 

</template>
<script>
    export default {
        name: 'About',
        data () {
            return {
              about: [
                        {
                            title: "用户协议",
                            content: ''

                        }
                    ],
              aboutImg:[
                {
                  img: require('../../static/other/aboutUs.png')
                }
              ]
            }
        }
    }
</script>

<style scoped>
  /* 公共 */
  .part{
    margin: 100px 0 200px 0;
  }
  .title{
    text-align: center;
    margin: 120px 0 50px 0;
    color: #317bcb;
  }
  .about_left{
    padding: 0% 5% 0% 5%;
  }
  .about_left ul{
    list-style: none;
    padding-left: 0;
  }
  .about_left ul li{
    text-decoration: none;
    line-height: 2em;
  }
  .about_left li img{
    margin-right: 10px;
  }
  .about_right img{
    width: 60%;
  }
    /* 屏幕设备适配 max-device-width: 400px */
    @media screen and (max-device-width: 415px) {
      .part{
        margin: 50px 0;
      }
      .title{
        margin: 0;
      }
      .about_left{
        padding: 5% 5% 5% 5%;
      }    
      .about_right img{
        width: 90%!important;
        margin-left: 5%;
      }
    }
</style>